import type { ResponseType } from "./runFetch"

export const ERROR_NAME = "AttensiFetchError"
export const DEFAULT_RESPONSE_TYPE: ResponseType = "json"
